import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { ImageType } from '../../../types.d/storeTypes';

import styles from './BlogNavigation.module.scss';

export type BlogNavigationItemProps = {
  image: ImageType;
  title: string;
  path: string;
  newTab: boolean;
};

export type BlogNavigationProps = {
  navigation: Array<BlogNavigationItemProps>;
  className?: string;
};

/**
 * The Blog Navigation section component.
 * @param {BlogNavigationProps} props - The component props.
 */
export const BlogNavigation = ({
  navigation,
  className,
}: BlogNavigationProps) => {
  const { asPath } = useRouter();

  return (
    <section className={clsx(styles.blogNavigation, className)}>
      {navigation.map((navigationItem, index) => {
        if (!navigationItem.image?.url) return null;
        const isPathEqual = asPath.split('?')[0] === navigationItem.path;

        return (
          <Link
            href={navigationItem.path}
            key={index}
            className={styles.blogNavigation__link}
            target={navigationItem.newTab ? '_blank' : undefined}
          >
            <Image
              height="180"
              width="180"
              alt={navigationItem.image?.title}
              title={navigationItem.image?.title}
              src={navigationItem.image?.url}
              className={clsx(
                styles.blogNavigation__img,
                isPathEqual && 'active'
              )}
            />
            <p className="text-utility-utility-small-mobile text-utility-utility-desktop">
              {navigationItem.title}
            </p>
          </Link>
        );
      })}
    </section>
  );
};
